import { z } from 'zod';
import { QuerySpecSchema } from './metrics-catalog.js';
export const ANALYSIS_QUESTIONS = [
    {
        kind: 'cohort_revenue',
        question: '어떤 유입 채널의 신규 고객이 가입 후 30일 동안 가장 많은 순매출을 만드는가?',
    },
    {
        kind: 'signup_funnel',
        question: '가입·청첩장 생성·AI 체험·결제 중 어디에서 가장 많이 멈추는가?',
    },
    {
        kind: 'cohort_conversion',
        question: '채널별 신규 가입자의 7일·30일 결제 전환율은 얼마인가?',
    },
    {
        kind: 'time_to_purchase',
        question: '신규 고객은 가입 후 첫 결제까지 얼마나 걸리는가?',
    },
    {
        kind: 'revenue_change',
        question: '최근 순매출 변화는 어떤 고객·상품·유입 채널에서 발생했는가?',
    },
    {
        kind: 'meta_acquisition',
        question: 'Meta 캠페인·소재 중 광고비 대비 신규 가입과 실제 구매 성과가 좋은 것은?',
    },
    {
        kind: 'traffic_gap',
        question: '광고 클릭은 많은데 사이트 방문이나 가입으로 이어지지 않는 캠페인은?',
    },
    {
        kind: 'landing_conversion',
        question: '어떤 랜딩 페이지와 기기에서 방문 대비 가입 성과가 낮은가?',
    },
    {
        kind: 'attribution_gap',
        question: 'Meta 보고 구매·매출과 내부 실제 결제는 얼마나 차이 나는가?',
    },
    {
        kind: 'ai_conversion',
        question: 'AI를 체험한 신규 고객과 체험하지 않은 고객의 결제율·순매출은 어떻게 다른가?',
    },
    {
        kind: 'refund_breakdown',
        question: '어떤 상품·유입 채널에서 환불이 많아 순매출이 줄어드는가?',
    },
    {
        kind: 'spend_change',
        question: '광고비를 늘린 기간에 방문·가입·구매·순매출은 각각 어떻게 변했는가?',
    },
];
export const AnalysisKindSchema = z.enum(ANALYSIS_QUESTIONS.map((item) => item.kind));
export const AnalysisChannelSchema = z.enum([
    'META_ADS',
    'INSTAGRAM',
    'NAVER',
    'GOOGLE',
    'KAKAO',
    'DIRECT',
    'REFERRAL',
    'PARTNER',
    'SMARTSTORE',
    'OTHER',
    'UNKNOWN',
]);
export const ProductAnalysisSpecSchema = z
    .object({
    kind: AnalysisKindSchema,
    range: QuerySpecSchema.shape.range,
    windowDays: z
        .union([z.literal(7), z.literal(30), z.literal(60), z.literal(90)])
        .default(30),
    channel: AnalysisChannelSchema.optional(),
    level: z.enum(['campaign', 'ad']).default('campaign'),
    groupBy: z.enum(['channel', 'product', 'customer']).default('channel'),
})
    .strict();
export const ProductAnalysisResultSchema = z.object({
    spec: ProductAnalysisSpecSchema,
    title: z.string(),
    summary: z.string(),
    columns: z.array(z.object({
        key: z.string(),
        label: z.string(),
        format: z.enum(['text', 'count', 'krw', 'percent', 'number']),
    })),
    rows: z
        .array(z.record(z.string(), z.union([z.string(), z.number().finite(), z.null()])))
        .max(200),
    sources: z.array(z.object({
        name: z.enum(['db', 'meta', 'ga4']),
        status: z.enum(['available', 'unavailable', 'partial']),
        fetchedAt: z.string().datetime(),
        detail: z.string(),
    })),
    definitions: z.array(z.string()),
    warnings: z.array(z.string()),
    generatedAt: z.string().datetime(),
    truncated: z.boolean(),
});
//# sourceMappingURL=product-analysis.js.map